
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

const STYLES = {
    label: {
        color: '#999999'
   }
};

const AttributeComboBoxField = ({
    fieldTitle,
    fieldName,
    onChange,
    options,
    values,
}) => {

    const handleChange = (e, item) => {
        if (onChange) {
            onChange(fieldName, item.key);
        }
    }

    const getOptions = () => {
        return options;
    }

    return (
        <ComboBox
            label={fieldTitle}
            selectedKey={values[fieldName] || ''}
            options={getOptions()}
            onChange={handleChange}
            styles={STYLES}
        />
    );
}

export default AttributeComboBoxField;
